import { BreakpointsRender, CUSTOM_LAPTOP_WIDTH } from '@components';

import { LoginSkeletonDesktop } from './loginSkeleton.desktop';
import { LoginSkeletonMobile } from './loginSkeleton.mobile';

export const LoginSkeleton = () => (
	<BreakpointsRender
		mobile={<LoginSkeletonMobile />}
		laptop={<LoginSkeletonDesktop />}
		customLaptopWidth={CUSTOM_LAPTOP_WIDTH}
	/>
);
